import { Page, Text, View } from '@react-pdf/renderer';

import { palette, styles } from '../styles';

interface CoverPageProps {
  brandName: string;
  aiProviderLabel: string;
  analysisDate: string;
  generatedAt: string;
}

export default function CoverPage({
  brandName,
  aiProviderLabel,
  analysisDate,
  generatedAt,
}: CoverPageProps) {
  return (
    <Page size="A4" style={styles.cover}>
      <View>
        <Text style={styles.coverEyebrow}>Yoast AI Brand Insights</Text>
        <Text style={styles.coverTitle}>Brand Analysis Report</Text>
        <Text style={styles.coverBrand}>{brandName}</Text>

        <View style={{ marginTop: 8 }}>
          <View style={styles.coverMetaRow}>
            <Text style={styles.coverMetaLabel}>AI platform</Text>
            <Text style={styles.coverMetaValue}>{aiProviderLabel}</Text>
          </View>
          <View style={styles.coverMetaRow}>
            <Text style={styles.coverMetaLabel}>Analysis date</Text>
            <Text style={styles.coverMetaValue}>{analysisDate}</Text>
          </View>
          <View style={styles.coverMetaRow}>
            <Text style={styles.coverMetaLabel}>Generated</Text>
            <Text style={styles.coverMetaValue}>{generatedAt}</Text>
          </View>
        </View>
      </View>

      <View style={styles.coverFooter}>
        <Text>
          This report summarises how the brand is represented across AI-generated
          answers — covering visibility, mentions, citations, competitor ranking
          and sentiment for the selected AI platform on the analysis date above.
        </Text>
        <Text style={{ marginTop: 6, color: palette.primary }}>
          yoast.com — AI Brand Insights
        </Text>
      </View>
    </Page>
  );
}
